/*
  Pre-sale ticket modal for sections/event-tickets.liquid.

  Deliberately not ticket-modal.js: there is nothing to price, nothing to select
  and nothing to submit, so all this does is open and close a panel. It answers
  to `data-tickets-*` rather than `data-ticket-*` because ticket-modal.js binds
  the first `[data-ticket-modal]` in the document and every `[data-ticket-trigger]`
  click — sharing the hooks would make the two modals fight the moment ticket
  sales are switched back on.
*/
(function () {
  var FOCUSABLE =
    'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  // Looked up per open() rather than captured once: the theme editor replaces the
  // whole section on every setting change, and a <script src> inside replaced
  // markup does not re-run — the captured node would be detached for the rest of
  // the editing session and the trigger would go dead.
  var root = null;
  var panel = null;
  var isOpen = false;
  var lastOpener = null;

  function focusable() {
    return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return !el.hasAttribute('disabled') && el.offsetParent !== null;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;

    var items = focusable();
    if (!items.length) {
      e.preventDefault();
      panel.focus({ preventScroll: true });
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;

    // The `!contains` arms are what actually hold the trap here: the only
    // tabbable element is the close button, and clicking a ticket-option row
    // (a plain <div>) drops focus to the dialog root or <body> — from where a
    // bare `active === first/last` test lets Tab walk out into the page behind.
    if (e.shiftKey) {
      if (active === first || active === panel || !panel.contains(active)) {
        e.preventDefault();
        last.focus({ preventScroll: true });
      }
    } else if (active === last || !panel.contains(active)) {
      e.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  function open(opener) {
    if (isOpen) return;

    root = document.querySelector('[data-tickets-modal]');
    panel = root && root.querySelector('[data-tickets-modal-panel]');
    if (!root || !panel) return;

    isOpen = true;
    lastOpener = opener || null;

    root.hidden = false;
    // One frame with the panel laid out but still translated, so the slide-in
    // transition runs instead of snapping.
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
    });

    // Same lock class as the real ticket modal — one of the two is ever open.
    document.documentElement.classList.add('is-ticket-modal-open');
    document.body.classList.add('is-ticket-modal-open');

    var initial = focusable()[0] || panel;
    if (initial && typeof initial.focus === 'function') initial.focus({ preventScroll: true });

    document.addEventListener('keydown', onKeydown, true);
  }

  function close() {
    if (!isOpen || !root) return;
    isOpen = false;

    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('is-ticket-modal-open');
    document.body.classList.remove('is-ticket-modal-open');

    document.removeEventListener('keydown', onKeydown, true);

    // Wait out the slide-down before `hidden` removes it from the tab order.
    var ms = 0;
    if (panel) {
      var seconds = parseFloat(String(window.getComputedStyle(panel).transitionDuration).split(',')[0]);
      if (!isNaN(seconds)) ms = seconds * 1000;
    }
    var closing = root;
    var hide = function () {
      if (!isOpen) closing.hidden = true;
    };
    if (ms > 0) setTimeout(hide, ms);
    else hide();

    if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus({ preventScroll: true });
    lastOpener = null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var trigger = e.target.closest('[data-tickets-trigger]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }

    if (e.target.closest('[data-tickets-modal-close]')) {
      e.preventDefault();
      close();
    }
  });
})();
